import { createContext, type RefObject } from "react";
import React, { useMemo, ReactNode } from "react";

import type { GridApi } from "ag-grid-community";
import type { AgGridReact } from "ag-grid-react";

type AgGridContextType = {
  gridRef: RefObject<AgGridReact>;
  readonly gridApi: GridApi | null;
};

interface AgGridProviderProps {
  gridRef: RefObject<AgGridReact>;
  children: ReactNode;
}

export const AgGridContext = createContext<AgGridContextType | undefined>(
  undefined
);

export const AgGridProvider: React.FC<AgGridProviderProps> = ({
  children,
  gridRef,
}) => {
  const value = useMemo<AgGridContextType>(
    () => ({
      gridRef,
      get gridApi() {
        return gridRef.current?.api ?? null;
      },
    }),
    []
  );

  return (
    <AgGridContext.Provider value={value}>{children}</AgGridContext.Provider>
  );
};
